var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEsg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 24,
    fill: "#EEF6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53 28.5H35.5C33.8431 28.5 32.5 29.8431 32.5 31.5V64.5C32.5 66.1569 33.8431 67.5 35.5 67.5H60.5C62.1569 67.5 63.5 66.1569 63.5 64.5V39M53 28.5L63.5 39M53 28.5V39H63.5",
    stroke: "#008CB7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52 47.154C51.0862 46.205 49.4781 45.546 48 45.504M48 45.504C46.2417 45.455 44.6673 46.282 44.6673 48.538C44.6673 52.692 52 50.615 52 54.769C52 57.139 50.0481 58.157 48 58.08M48 45.504V43M44 56.154C44.8599 57.344 46.4574 58.022 48 58.08M48 58.08V61",
    stroke: "#008CB7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsg3);
export default __webpack_public_path__ + "static/media/esg3.598725b865d46c39bcb1881ed7e3cd3e.svg";
export { ForwardRef as ReactComponent };